(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mobile-toolbar"]) return;
  try {
    
(function () {
  var mobile = window.matchMedia('(max-width: 767px)');
  var ready = false;
  var attempts = 0;
  function active() { return mobile.matches && !!document.querySelector('.mbtlwraper .sfh-rep-help'); }
  function sync() { if (ready) { if (active()) { window.rep.hide(); } else { window.rep.show(); } } }
  function connect() {
    if (ready || !window.rep || typeof window.rep.open !== 'function' || typeof window.rep.hide !== 'function' || typeof window.rep.show !== 'function') return;
    ready = true;
    if (typeof window.rep.on === 'function') window.rep.on('close', function () { if (active()) window.rep.hide(); });
    sync();
  }
  connect();
  var timer = window.setInterval(function () { connect(); attempts += 1; if (ready || attempts >= 240) window.clearInterval(timer); }, 250);
  mobile.addEventListener('change', sync);
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.sfh-rep-help');
    if (!link) return;
    connect();
    if (!ready) return;
    event.preventDefault();
    window.rep.show();
    window.rep.open();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
if (!customElements.get('sfh-pickup-status')) {
  customElements.define('sfh-pickup-status', class extends HTMLElement {
    connectedCallback() {
      this.connect = () => {
        if (!this.isConnected || this.unsubscribe || typeof subscribe !== 'function') return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.section) return;
          const updated = event.data.html.getElementById(this.id);
          if (updated) this.innerHTML = updated.innerHTML;
        });
      };
      this.connect();
      window.addEventListener('load', this.connect, { once: true });
    }
    disconnectedCallback() {
      window.removeEventListener('load', this.connect);
      if (this.unsubscribe) this.unsubscribe();
      this.unsubscribe = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
